export enum EnvironmentEnum {
    Development = "Development",
    Test = "Test",
    Staging = "Acceptatie",
    Production = "Production"
}